import { Fragment } from "react";
import { Info } from "@mui/icons-material";
import styled from "styled-components";
import { Grid, IconButton, InputAdornment, MenuItem } from "@mui/material";

import { colors } from "../../../../css components/Style";
import {
  TextField,
  FileUpload,
  ComponentHeader,
} from "../../../../../components";
import BrandDetailsDialog from "../../../brand details components/BrandDetailsDialog";
import MUIDateTimePicker from "../../../../../components/DateTimePicker";

const ImageDiv = styled.div`
  width: 286px;
  height: 120px;
  border: 1px solid #d6cbcb;
  border-radius: 10px;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: fill;
  border-radius: 10px;
`;

export default function FormOne({
  formikProps,
  editState,
  brandIdentity,
  component,
  brandDetails,
  setBrandDetails,
}) {
  const onImageError = (e) => {
    e.target.src =
      "https://dc-chat-media.s3.ap-south-1.amazonaws.com/NaN_placeholder.png";
  };

  return (
    <Fragment>
      <Grid size={12}>
        <ComponentHeader title="Campaign Details" />
      </Grid>

      {!!formikProps.values.previewImage && (
        <Fragment>
          <Grid size={12}>
            <ImageDiv>
              <Image
                src={formikProps.values.previewImage}
                alt="!"
                onError={onImageError}
              />
            </ImageDiv>
          </Grid>
        </Fragment>
      )}

      {(component === "superadmin" || component === "accepted") && (
        <Fragment>
          <Grid size={4}>
            <TextField
              size="small"
              label="Brand Name"
              name="brand_name"
              placeholder="Brand Name"
              disabled={!editState}
              value={brandDetails?.data?.brandName}
              InputProps={{
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <IconButton
                      onClick={() =>
                        setBrandDetails((prevVal) => ({
                          ...prevVal,
                          state: true,
                        }))
                      }
                      style={{ padding: "0" }}
                    >
                      <Info style={{ color: colors.publicisBlue }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Fragment>
      )}

      <Grid size={4}>
        <TextField
          required
          name="campaign_name.value"
          placeholder="Name"
          label="Name"
          formikProps={formikProps}
          disabled={!editState}
        />
      </Grid>

      <Grid size={4}>
        <TextField
          required
          select
          name="campaign_type.value"
          placeholder="Campaign Goal"
          label="Campaign Goal"
          formikProps={formikProps}
          disabled={!editState}
          value={formikProps.values.campaign_type?.value ?? ""}
        >
          <MenuItem value="" disabled>
            Select Campaign Goal
          </MenuItem>
          <MenuItem value="BRANDING">Branding</MenuItem>
          <MenuItem value="CONSIDERATION">Consideration</MenuItem>
          <MenuItem value="LEAD_GENERATION">Lead Generation</MenuItem>
          <MenuItem value="NOT_DEFINED">Not Defined</MenuItem>
        </TextField>
      </Grid>

      <Grid size={4}>
        {!brandIdentity && (
          <FileUpload
            required
            disabled={!editState}
            name="previewImage"
            formikProps={formikProps}
            label={"Preview Image"}
            placeholder="Select Preview Image"
            allowedExtension=".jpg,.jpeg,.png,.gif"
            value={formikProps.values.previewImage
              ?.split("/")
              .pop()
              .slice(
                formikProps.values?.previewImage
                  ?.split("/")
                  .pop()
                  .indexOf("_") + 1
              )}
            folderPath={"public/preview_images/" + new Date().getTime() + "_"}
          />
        )}
      </Grid>

      {(!brandIdentity ||
        component === "accepted" ||
        component === "superadmin") && (
        <Fragment>
          <Grid size={4}>
            <TextField
              required
              name="destination_url.value"
              formikProps={formikProps}
              placeholder="Destination URL"
              disabled={!editState}
              label="Destination URL"
            />
          </Grid>
        </Fragment>
      )}

      <Grid size={4}>
        <MUIDateTimePicker
          name="start_duration.value"
          formikProps={formikProps}
          label="Start Duration"
          minDateTime={new Date()}
          disabled={!editState}
          alternate="startTime"
        />
      </Grid>

      <Grid size={4}>
        <MUIDateTimePicker
          name="end_duration.value"
          formikProps={formikProps}
          label="End Duration"
          minDateTime={
            formikProps.values.start_duration.value
              ? (() => {
                  const start = new Date(
                    formikProps.values.start_duration.value
                  );
                  const end = new Date(formikProps.values.end_duration.value);

                  const isSameDay =
                    start.setHours(0, 0, 0, 0) === end.setHours(0, 0, 0, 0);

                  return isSameDay
                    ? new Date(
                        new Date(
                          formikProps.values.start_duration.value
                        ).getTime() +
                          30 * 60 * 1000
                      )
                    : new Date(formikProps.values.start_duration.value);
                })()
              : new Date()
          }
          disabled={!editState}
          alternate="endTime"
        />
      </Grid>

      <Grid size={4}>
        <TextField
          name="about.value"
          placeholder="About Campaign"
          multiline
          label="About Campaign"
          formikProps={formikProps}
          disabled={!editState}
        />
      </Grid>

      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
    </Fragment>
  );
}
